









import {
  SubscribedPaidMembershipPlan,
  UnsubscribedPaidMembershipPlan
} from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import { DateFormat } from '@/util/format'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class PlanSubscribingPeriod extends Vue {
  @Prop({ required: true })
  readonly plan: SubscribedPaidMembershipPlan | UnsubscribedPaidMembershipPlan

  readonly formatDate = DateFormat.yyyyMmDd
}
